import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { OnboardingService } from '../onboarding.service';
import {MatDialog} from '@angular/material/dialog';
import { RecaptchaService } from '../recaptcha.service';
import { TwitterService } from '../../services/twitter.service';

@Component({
    selector: 'app-airdrop-twitter',
    templateUrl: './airdrop-twitter.component.html',
    styleUrls: [ './airdrop-twitter.component.scss' ]
})
export class AirdropTwitterComponent implements OnInit {
    width: any;
    @Input() task = {
        id: '',
        title: '',
        desc: '',
        icon: '',
        status: 'Pending',
        reward: 0,
        multiplier: false,
        redirect_url: '',
        cta: '',
        coming_soon: false
    };

    constructor(public httpService: HttpService,
        private twitterService: TwitterService,
        private cfAlertService: CfAlertService,
        private recaptchaService: RecaptchaService,
        private onboardingService: OnboardingService,
        private dialog: MatDialog
    ) {
        this.window = getWindow();
        this.width = this.window.outerWidth;
    }
    
    use_manual_recaptcha: boolean = false;
    window: Window;

    public twitter: any = {
        loading: false,
        accountConnected: false
    };

    twitter_join_loading: boolean = false;
    twitterJoined: boolean = false;

    ngOnInit(): void {

    }

    attachSocketEvents() {
        
    }

    connectTwitter() {
        // this.window.open(this.task.redirect_url, '_blank');

        this.twitter_join_loading = true;

        const body = {
            social_media_type: 'twitter'
        };

        this.apiCall(body);
        // this.window.open(this.task.redirect_url, '_blank');
    }

    async apiCall(body: any) {
        const recaptcha = await this.recaptchaService.getRecaptcha('joinSocialMedia', this.use_manual_recaptcha);

        body = {
            ...body, 
            ...recaptcha
        };
        this.onboardingService.updateSocialMedia(body).subscribe((res: any) => {
            if (body.social_media_type === 'twitter') {
                this.twitter_join_loading = false;
                this.twitterJoined = true;

                if (!this.httpService.user.twitter) {
                    this.httpService.user.twitter = {
                        group_joined: true,
                        share_on_twitter: false,
                        credit_score: false,
                        user_id: 0,
                        screen_name: ''
                    };
                }

                this.httpService.user.twitter.group_joined = true;
                this.window.open(this.task.redirect_url, '_blank');
            }

            this.cfAlertService.showMessage(res.message);
        }, (err: HttpErrorResponse) => {
            console.error('refferal code update error');
            console.error(err);

            if (err.error.message === 'Invalid recaptcha') {
                this.use_manual_recaptcha = true;
                this.apiCall(body);

                return ;
            }

            this.cfAlertService.showError(err);

            if (body.social_media_type === 'twitter')
                this.twitter_join_loading = false;
        });
    }
}
